<template>
    <div
        v-if="isOpen"
        class="reg-dialog"
        role="presentation"
    >
        <div
            class="reg-dialog__backdrop"
            @click="close"
        ></div>
        <div
            class="reg-dialog__panel"
            role="dialog"
            aria-modal="true"
            aria-labelledby="reg-dialog-title"
            @click.stop
        >
            <button
                type="button"
                class="reg-dialog__close"
                aria-label="Zamknij"
                @click="close"
            >
                &times;
            </button>
            <h2
                id="reg-dialog-title"
                class="reg-dialog__title"
            >
                Rejestracja
            </h2>
            <p class="reg-dialog__message">{{ message }}</p>
            <div
                class="reg-dialog__progress"
                aria-hidden="true"
            >
                <div
                    class="reg-dialog__progress-bar"
                    :style="{ transform: 'scaleX(' + progress + ')' }"
                ></div>
            </div>
            <button
                type="button"
                class="reg-dialog__ok"
                @click="close"
            >
                OK
            </button>
        </div>
    </div>
</template>

<script>
const AUTO_CLOSE_MS = 10000;

export default {
    props: {
        message: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            isOpen: true,
            progress: 1,
            rafId: null,
            startedAt: 0,
        };
    },
    mounted() {
        document.body.classList.add("reg-dialog-open");
        this.startedAt = performance.now();
        this.tick();
        window.addEventListener("keydown", this.onKeydown);
    },
    beforeDestroy() {
        this.teardown();
    },
    methods: {
        tick() {
            const elapsed = performance.now() - this.startedAt;
            const remaining = Math.max(0, 1 - elapsed / AUTO_CLOSE_MS);
            this.progress = remaining;

            if (remaining <= 0) {
                this.close();
                return;
            }

            this.rafId = window.requestAnimationFrame(this.tick);
        },
        onKeydown(event) {
            if (event.key === "Escape") {
                this.close();
            }
        },
        close() {
            if (!this.isOpen) {
                return;
            }
            this.isOpen = false;
            this.teardown();
        },
        teardown() {
            if (this.rafId !== null) {
                window.cancelAnimationFrame(this.rafId);
                this.rafId = null;
            }
            document.body.classList.remove("reg-dialog-open");
            window.removeEventListener("keydown", this.onKeydown);
        },
    },
};
</script>
